export default [
  'account, account_preferences',
  'upload_contact',
  'contactgroup',
  'signupform',
  'task',
]
